export const APP_PATHS = {
  MANAGE_TAB: '/manage',
  ANALYZE_TAB: '/analyze',
  HEALTH_TAB: '/health',
  COMPARISON_TAB: '/compare'
};